import { render, staticRenderFns } from "./EnvironmentWarning.vue?vue&type=template&id=1655da95&scoped=true&"
import script from "./EnvironmentWarning.vue?vue&type=script&lang=js&"
export * from "./EnvironmentWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1655da95",
  null
  
)

export default component.exports